import { FormEditStudent } from 'teacher-ui-client/components/form/edit-student'
import { usesExternalAuthentication } from 'teacher-ui-client/helpers/uses-external-authentication'
import { usesExternalProvisioning } from 'teacher-ui-client/helpers/uses-external-provisioning'
import { usesExternalRostering } from 'teacher-ui-client/helpers/uses-external-rostering'
import type ManageStudentsStudentRoute from 'teacher-ui-client/manage/students/student/route'

import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<ManageStudentsStudentRoute>
  }
}
export const ManageStudentsStudentPage: TOC<Signature> = <template>
  {{#if @model}}
    <FormEditStudent
      class="m-4 max-w-6xl"
      @student={{@model.student}}
      @usesExternalAuthentication={{(usesExternalAuthentication)}}
      @usesExternalProvisioning={{(usesExternalProvisioning)}}
      @usesExternalRostering={{(usesExternalRostering)}}
    />
  {{/if}}
</template>

export default RouteTemplate(ManageStudentsStudentPage)
